import { render, staticRenderFns } from "./BpcTableSubscriptions.vue?vue&type=template&id=8522e0a2&"
import script from "./BpcTableSubscriptions.vue?vue&type=script&lang=js&"
export * from "./BpcTableSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./BpcTableSubscriptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports